import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
    private readonly BASE_URL: string;

    constructor(
        private http: HttpClient
    ) {
        this.BASE_URL = `${environment.serverURL}/checkout`;
    }

    generateToken(): Observable<any> {
        return this.http.get(`${this.BASE_URL}/generate-token`);
    }

    getCustomerById(): Observable<any> {
        return this.http.get(`${this.BASE_URL}/get-customer-by-id`);
    }

    payOrder(body: any): Observable<any> {
        return this.http.post(`${this.BASE_URL}/pay-order`, body);
    }

    getCustomerPayments(): Observable<any> {
        return this.http.get(`${this.BASE_URL}/get-payments`);
    }

    requestNewCustomer(payload: any): Observable<any> {
        return this.http.post(`${this.BASE_URL}/generate-customer`, payload);
    }

    addCardToCustomer(customer: any, token: any): Observable<any> {
        const payload = {
            customer,
            token,
            sw_default: 0,
        };

        return this.http.post(`${this.BASE_URL}/add-payment`, payload);
    }

    setDefaultPayment(payment_src: string): Observable<any> {
        const body = { payment_src };
        return this.http.post(`${this.BASE_URL}/set-default-payment`, body);
    }

    getDefaultPayment(): Observable<any> {
        return this.http.get(`${this.BASE_URL}/get-default-payment`);
    }

    removePayment(payment: any): Observable<any> {
        const body = {
          customer_id: payment.parent_id,
          payment_src: payment.id
        };

        return this.http.post(`${this.BASE_URL}/remove-payment`, body);
    }

    verifyUserInfo(): Observable<any> {
        return this.http.get<any>(`${this.BASE_URL}/verify-user-info`);
    }
}
